<template>
  <Report v-if="loaded"
          :entity-name="entityName"
          :entity-id="entityId"
          :entity-value="entityValue"
          :side="side"
          :icon-only="iconOnly"
          :button-class="buttonClass"
  />
</template>

<script>
import Report from "./Report.vue";

export default {
  name: "ReportContainer",
  components: { Report },
  data() {
    return {
      entityName: null,
      entityId: null,
      entityValue: null,
      buttonClass: 'btn btn-link btn-sm',
      iconOnly: false,
      side: 'end',
      loaded: false,
    }
  },
  mounted() {
    this.entityName = this.$el.parentNode.getAttribute('data-vue-entity-name') || null;
    this.entityId = this.$el.parentNode.getAttribute('data-vue-entity-id') || null;
    this.entityValue = this.$el.parentNode.getAttribute('data-vue-entity-value') || null;
    this.buttonClass = this.$el.parentNode.getAttribute('data-vue-button-class') || 'btn btn-link btn-sm';
    this.iconOnly = this.$el.parentNode.getAttribute('data-vue-icon-only') === "true";
    this.side = this.$el.parentNode.getAttribute('data-vue-side') || 'end';
    this.loaded = true;
  }
}
</script>

<style scoped>

</style>
